import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiInfo } from "react-icons/fi";
import LocationItem from "../Address/LocationItem";

const LocationSelectorSection = ({
  title,
  tooltipText,
  selectedItem,
  onSelectClick,
  onClearItem,
  selectLabel,
  changeLabel,
  hidePhone,
}) => {
  return (
    <div className="pickup-point-selection d-flex flex-column align-items-center justify-content-center mb-3">
      <div className="address-header pickup-point-selected-header col-12 p-0 d-flex justify-content-between flex-column flex-md-row">
        <div className="d-flex flex-row align-items-center justify-content-start">
          <h3 className="mb-0">{title}</h3>
          <OverlayTrigger
            key={`${title}-tooltip`}
            placement="auto"
            overlay={
              <Tooltip id={`${title}-tooltip`} className="pickup-point-tooltip">
                {tooltipText}
              </Tooltip>
            }
            delayShow={300}
            delayHide={150}
          >
            <span className="pickup-point-tooltip">
              <FiInfo />
            </span>
          </OverlayTrigger>
        </div>
        {selectedItem ? (
          <a className="pickup-point-select-btn" onClick={onSelectClick}>
            {changeLabel}
          </a>
        ) : null}
      </div>
      {selectedItem ? (
        <div className="pickup-point-selected w-100">
          <LocationItem
            item={selectedItem}
            onClear={onClearItem}
            hidePhone={hidePhone}
          />
        </div>
      ) : (
        <a className="pickup-point-action" onClick={onSelectClick}>
          {selectLabel}
        </a>
      )}
    </div>
  );
};

export default LocationSelectorSection;
